import React from "react";

import { BiSearch } from "react-icons/bi";

const SearchInput = ({ value, onChange, placeholder = "Search..." }) => {
    return (
        <div className="relative w-full max-w-md">
            <input
                type="text"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className="border md:w-auto w-full ps-12 border-gray-300 rounded-md p-2  bg-white  flex justify-between items-center focus:bg-white shadow-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300 text-gray-800"
            />
            <BiSearch className="w-6 h-6 text-gray-500 absolute left-4 top-1/2 transform -translate-y-1/2" />
        </div>
    );
};

export default SearchInput;
